import { useEffect, useState } from 'react';
import { collection, onSnapshot, orderBy, query } from 'firebase/firestore';
import { db } from '../lib/firebase';

// Real-time subscription to users/{uid}/runs ordered by createdAt desc
export function useUserRuns(user) {
  const [runs, setRuns] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (!user) {
      setRuns([]);
      setLoading(false);
      return undefined;
    }

    setLoading(true);
    setError(null);

    const q = query(
      collection(db, 'users', user.uid, 'runs'),
      orderBy('createdAt', 'desc')
    );

    const unsubscribe = onSnapshot(
      q,
      (snap) => {
        setRuns(snap.docs.map((d) => ({ id: d.id, ...d.data() })));
        setLoading(false);
      },
      (err) => {
        console.error('[useUserRuns] snapshot error:', err);
        setError(err);
        setLoading(false);
      }
    );

    return unsubscribe;
  }, [user]);

  return { runs, loading, error };
}
